import { colors, spacing } from "../../UIGlobals";
/** @jsx jsx */
import { jsx } from "@emotion/react";

export const RenderSelectField = ({
    input,
    meta: { touched, error },
    errorRes,
    children,
    ...custom
}) => (
    <div>
        <select {...input} {...custom}>
            {children}
        </select>
        {touched && (error || errorRes) && (
            <span
                css={{
                    display: "block",
                    color: colors.red,
                    fontSize: 14,
                    paddingTop: spacing.space0,
                }}
            >
                {error || errorRes}
            </span>
        )}
    </div>
);
